import { Controller } from '@hotwired/stimulus';

export default class LegalEntityNifController extends Controller {
  static targets = ['country', 'nifContainer', 'nifInput'];

  connect() {
    this.updateVisibility();
  }

  updateVisibility() {
    const shouldShowNif = this.countryTarget.value.toUpperCase() === 'ES';

    this.nifContainerTarget.classList.toggle('d-none', !shouldShowNif);
    this.nifInputTarget.required = shouldShowNif;
  }
}
